import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Table, Input, Tooltip, Button, Popconfirm } from "antd";
import {
  DeleteOutlined,
  EditOutlined,
  SearchOutlined,
} from "@mui/icons-material";
import {
  useAllProducts,
  useDeleteProduct,
  useSearchProducts,
} from "../../../api/products/products";

const Products = () => {
  const [searchText, setSearchText] = useState("");
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const navigate = useNavigate();
  const { mutate: deleteProduct, isLoading: deleting } = useDeleteProduct();

  const { data: searchedProducts = [], isLoading: searching } =
    useSearchProducts(searchText);

  const { data: allProducts = [], isLoading: loadingAll } = useAllProducts();

  const products = searchText ? searchedProducts : allProducts;
  const isLoading = searchText ? searching : loadingAll;

  const filteredProducts = products;

  const columns = [
    {
      title: "No.",
      render: (_, __, index) => index + 1 + (page - 1) * pageSize,
    },
    {
      title: "Name",
      dataIndex: "name",
    },
    {
      title: "SKU",
      dataIndex: "sku",
    },
    {
      title: "HSN",
      dataIndex: "hsn",
    },
    {
      title: "Price (₹)",
      dataIndex: "price",
    },
    {
      title: "GST (%)",
      dataIndex: "gst",
    },
    {
      title: "Weight (kg)",
      dataIndex: "weight",
    },

    {
      title: "Action",
      render: (_, row) => (
        <div className="flex gap-4">
          <Tooltip title="Edit Product">
            <Button
              type="default"
              icon={<EditOutlined />}
              className="!bg-primary !border-primary text-white"
              onClick={() => navigate(`/products/edit-product/${row._id}`)}
            />
          </Tooltip>
          <Popconfirm
            title="Are you sure you want to delete this user?"
            onConfirm={() => deleteProduct(row._id)}
            okText="Yes"
            cancelText="No"
          >
            <Tooltip title="Delete">
              <Button
                icon={<DeleteOutlined />}
                type="default"
                className="!bg-delete !border-delete text-white"
                loading={deleting}
              />
            </Tooltip>
          </Popconfirm>
        </div>
      ),
    },
  ];

  return (
    <div className="space-y-4">
      <div className="flex justify-between flex-wrap gap-4 items-center">
        <div className="relative w-80">
          <Input
            placeholder="Search by Name or SKU"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            prefix={<SearchOutlined className="text-iconDefault" />}
            className="border border-borderDefault focus:border-primary"
          />
        </div>
        <button
          onClick={() => navigate("/products/add")}
          className="px-6 py-2 rounded text-primary bg-primaryLight hover:bg-primary hover:text-white border border-primary transition-colors duration-300"
        >
          Add Product
        </button>
      </div>

      <Table
        rowKey="_id"
        columns={columns}
        loading={isLoading}
        dataSource={filteredProducts}
        pagination={{
          current: page,
          pageSize,
          total: filteredProducts.length,
          showSizeChanger: true,
          pageSizeOptions: [5, 10, 20, 40],
          onChange: (current, size) => {
            setPage(current);
            setPageSize(size);
          },
        }}
      />
    </div>
  );
};

export default Products;
